import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class WorkFlowStepLogging extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            entityId: props.EntityId,
            type: props.Type,
            workFlowStepId: props.WorkFlowStepId,
            data: null,
            loading: true,
            description: '',
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/workflowsteplog/get", {
            entityId: this.state.entityId,
            type: this.state.type,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e,action) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/workflowsteplog/save", {
            entityId: this.state.entityId,
            type: this.state.type,
            workFlowStepId: this.state.workFlowStepId,
            description: this.state.description,
            action,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="row">
            {this.state.data.record.histories.map(hist => <div className="row">
                <div className="col-lg-12" style={{ backgroundColor: "#f0f0f0", borderRadius: "4px", marginBottom: "5px" }}>
                    <label className="form-label">{hist.actionString } توسط {hist.personName} در تاریخ <b>{hist.dateString}</b> در گام <b>{hist.stepName}</b></label>
                    <p>{hist.description}</p>
                </div>
            </div>)}
            {this.state.data.record.verifyAccess === true && <div className="row">
                <div className="col-lg-12">
                    <label className="form-label">توضیحات مربوط به تایید/رد مرحله:</label>
                    <input type="text" defaultValue={this.state.description} onChange={e => this.state.description = e.target.value} className="form-input" />
                </div>
                <div className="col-lg-1">
                    <button type="button" className="btn btn-danger w-100" onClick={e => this.save(e, 2)}>رد مرحله</button>
                </div>
                <div className="col-lg-1">
                    <button type="submit" onClick={e => this.save(e, 1)} className="btn btn-success w-100">تایید مرحله</button>
                </div>
            </div>}
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}